// extracted by mini-css-extract-plugin
export default {"title":"Products_title__d0pAQ","description":"Products_description__2pJN9"};